import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function MenuPacientes() {

    const [permisos, setPermisos] = useState([]);
    const [client, setClient] = useState([]); // 🔧 Agregar estado para client
    const [loggedIn, setLoggedIn] = useState(false); // 🔧 Agregar estado para loggedIn
    let userdata = [];

    useEffect(()=>{

        if (!localStorage.getItem('userdata')) {
            setLoggedIn(true);
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));
        
        // 🔒 VALIDACIÓN DE PERMISOS - Patrón híbrido (nuevo + legacy)
        let permisosList = [];
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            permisosList = userdata.permissions.map(p => p.slug);
        } else if (userdata.up) {
            permisosList = userdata.up;
        }
        
        setPermisos(permisosList);

        // ✅ Sin config manual - el interceptor agrega el token automáticamente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
                setLoggedIn(true); // Permitir continuar aunque falle la carga del cliente
            });

    },[]);

    if (loggedIn) {
        return  <div className="hold-transition">
                    <Header client={client} />
                    <Aside client={client} activelink="patients" />
                    
                    <div className="content-wrapper">
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-8">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                            <li className="breadcrumb-item">Clientes</li>
                                        </ol>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-sm-8">
                                        <h1 className="m-0">Opciones Clientes</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className="content" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-3 col-6">
                                        <div className="small-box bg-custom-dark">
                                            <div className="inner">
                                                <h3>&nbsp;</h3>
                                                <p>Buscar Paciente</p>
                                            </div>
                                            <div className="icon">
                                                <i className="fas fa-search"></i>
                                            </div>
                                            <Link to="/pacientes" className="small-box-footer">
                                                Buscar <i className="fas fa-arrow-circle-right"></i>
                                            </Link>
                                        </div>
                                    </div>

                                    {permisos.includes('crearPacientes') && (
                                        <div className="col-lg-3 col-6">
                                            <div className="small-box bg-custom-dark">
                                                <div className="inner">
                                                    <h3>&nbsp;</h3>
                                                    <p>Nuevo Paciente</p>
                                                </div>
                                                <div className="icon">
                                                    <i className="fas fa-user-plus"></i>
                                                </div>
                                                <Link to="/crear-paciente" className="small-box-footer">
                                                    Crear <i className="fas fa-arrow-circle-right"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    )}




                                     {permisos.includes('crearPacientes') && (
                                        <div className="col-lg-3 col-6">
                                            <div className="small-box bg-custom-dark">
                                                <div className="inner">
                                                    <h3>&nbsp;</h3>
                                                    <p>Nueva Empresa</p>
                                                </div>
                                                <div className="icon">
                                                    <i className="fas fa-building"></i>
                                                </div>
                                                <Link to="/crear-empresa" className="small-box-footer">
                                                    Crear <i className="fas fa-arrow-circle-right"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    )}

                                    {permisos.includes('crearPacientes') && (
                                        <div className="col-lg-3 col-6">
                                            <div className="small-box bg-custom-dark">
                                                <div className="inner">
                                                    <h3>&nbsp;</h3>
                                                    <p>Listar Empresas</p>
                                                </div>
                                                <div className="icon">
                                                    <i className="fas fa-list"></i>
                                                </div>
                                                <Link to="/listar-empresas" className="small-box-footer">
                                                    Ver Lista <i className="fas fa-arrow-circle-right"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </section>
                    </div>
                    <Footer showToast={false} delay={0} />
                </div>
    }

    return (
        <Loading />
    );
}
export default MenuPacientes;